module.exports = __webpack_public_path__ + "img/jr_banner_tr.afb10eef.jpg";